import { render, staticRenderFns } from "./PreviewLocationAttribute.vue?vue&type=template&id=166b6843&scoped=true"
import script from "./PreviewLocationAttribute.vue?vue&type=script&lang=js"
export * from "./PreviewLocationAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b6843",
  null
  
)

export default component.exports